import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useExtrasAndContradictionsContext } from "context/extrasAndContradictions/ExtrasAndContradictionsContext"
import LayoutExtrasAndContradictions from "./LayoutExtrasAndContradictions"
import CollapsableChapter from "./CollapsableChapter"
import Loader from "common/Loader"
import ModalDeletePart from "components/Budgeting2023/TablaPartida/ModalDeletePart"
import ModalDeletePartEnum from "common/ModalDeletePartEnum"
import DownloadBudgetEnum from "common/DownloadBudgetEnum"
import DownloadBudget from "components/Feed/DownloadBudget"
import { useProjectContext } from "context/projects/projectContext"
import { useWrapperModals } from "context/wrapperModals/WrapperModalsContext"
import { EXTRAS_AND_CONTRADICTIONS } from "context/types"
import { useBudget2023Context } from "context/budget2023/Budget2023Context"
import i18n from "i18n"

const ExtrasAndContradictionsStructure = () => {
  const { projectId } = useParams()

  const { isBudgetClosed: isBudgetClosedFromContext } = useBudget2023Context()

  const { projectInfo } = useProjectContext()
  const { tree, loading, showDeletePartModal, deletingFromPart, dispatchs } =
    useExtrasAndContradictionsContext()

  const { setTree, setShowDeletePartModal } = dispatchs

  const { newModalPart: budgetModalPart } = useWrapperModals()

  useEffect(() => {
    setTree(projectId)
  }, [projectId])

  if (loading) {
    return <Loader />
  }

  const treeMatchesRoute =
    tree != null &&
    projectId != null &&
    String(tree.projectId) === String(projectId)

  const isBudgetClosed = treeMatchesRoute
    ? Boolean(tree.isBudgetClosed)
    : Boolean(isBudgetClosedFromContext)

  const showAddPartida = item => {
    return isBudgetClosed && item.chapterId === tree.extraChapter
  }

  const closedBudgetHintKeyForChapter = item => {
    if (isBudgetClosed) return undefined
    if (item.chapterId === tree.extraChapter) {
      return "extras.closedBudgetForNewExtraLine"
    }
    if (item.chapterId === tree.contradictoryChapter) {
      return "extras.closedBudgetForNewContradictoryLine"
    }
    return undefined
  }

  const contradictoryClosedGuideUrlForChapter = item => {
    if (!isBudgetClosed || item.chapterId !== tree.contradictoryChapter) {
      return undefined
    }
    return i18n.t("extras.contradictoryStepsHelpArticleUrl")
  }

  return (
    <>
      <LayoutExtrasAndContradictions>
        <div>
          {tree?.chapters?.length > 0 ? (
            tree.chapters.map((item, index) => (
              <CollapsableChapter
                key={item.chapterId}
                chapter={item}
                chapterIndex={index}
                showAddPartBtn={showAddPartida(item)}
                closedBudgetHintKey={closedBudgetHintKeyForChapter(item)}
                contradictoryClosedGuideUrl={contradictoryClosedGuideUrlForChapter(
                  item,
                )}
                setOpenNewModalPart={isOpen =>
                  budgetModalPart.setProperty({
                    open: isOpen,
                    chapterId: item.chapterId,
                    srcPage: EXTRAS_AND_CONTRADICTIONS,
                    from: EXTRAS_AND_CONTRADICTIONS,
                    partida: null,
                  })
                }
              />
            ))
          ) : (
            <h1>No hay nada</h1>
          )}
        </div>
      </LayoutExtrasAndContradictions>
      <div aria-describedby="Modals">
        <ModalDeletePart
          openEliminate={showDeletePartModal}
          setOpenEliminate={setShowDeletePartModal}
          partida={deletingFromPart}
          from={ModalDeletePartEnum.FROM_EXTRAS_AND_CONTRADICTIONS}
        />

        <DownloadBudget
          open={false}
          setOpen={() => {}}
          name={projectInfo?.name ?? ""}
          soyFinal={false}
          fromTab={DownloadBudgetEnum.FROM_EXTRAS_AND_CONTRADICTIONS}
        />
      </div>
    </>
  )
}

export default ExtrasAndContradictionsStructure
